import {
  QriDetailsBulkV2MetadataParser,
  QriDetailsV2,
} from '@qualio/search-qri';
import axios from 'axios';
import { getQriServiceUrl } from '../util/QriUrlUtils';

export const qriApiClient = axios.create({
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
  baseURL: getQriServiceUrl(false),
  withCredentials: true,
});

export const setQriApiClientBaseUrl = (qriServiceUrl: string) => {
  qriApiClient.defaults.baseURL = qriServiceUrl;
};

const MAX_QRIS_PER_REQUEST = 100;

const chunk = <T>(items: T[], size: number): T[][] => {
  const chunks: T[][] = [];
  for (let i = 0; i < items.length; i += size) {
    chunks.push(items.slice(i, i + size));
  }
  return chunks;
};

export const QriApi = {
  async getQriDetails(qris: string[]): Promise<QriDetailsV2[]> {
    const uniqueQris = Array.from(new Set(qris));
    const batches = chunk(uniqueQris, MAX_QRIS_PER_REQUEST);

    const results = await Promise.all(
      batches.map(async (batch) => {
        const result = await qriApiClient.post(
          `/v2/details`,
          {
            qris: batch,
          },
          {
            params: {
              metadata: true,
            },
          },
        );
        return Object.values(
          QriDetailsBulkV2MetadataParser.parse(result.data).data.items,
        );
      }),
    );

    return results.flat();
  },
};
